/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import ActualStage from './actual-stage';
import * as ResultsUtils from '../utils/results';

export default class SecondOrderActualStage extends ActualStage {
  whoAmI = 'app/models/stages/actual-second-order.js';

  getActualFpArray(loopFp) {
    return [loopFp, loopFp * 0.99, loopFp * 0.99, loopFp, loopFp * 0.96, loopFp, loopFp * 0.99];
  }

  getActualQArray(loopQ) {
    return [loopQ, loopQ * 1.005, loopQ, loopQ * 1.01, loopQ * 1.1, loopQ * 1.01, loopQ];
  }

  getActualGainArray(gain) {
    return [1, 1, 1, 1, 1, gain * 0.98, gain * 0.98];
  }

  @computed('filter', 'stageFp', 'stageQ', 'gain') get stepResponseSetup() {
    var base = this; // for readability. To know which properties are declared in the base class
    var filter = base.filter;
    var actualStageFp = base.stageFp;
    var actualStageQ = base.stageQ;
    var gain = base.gain;
    var result = filter.setupSecondOrderStepResponse(actualStageFp, actualStageQ, gain);
    return result;
  }

  @computed('timeAxis', 'stepResponseSetup') get stepResponseIdeal() {
    var timeAxis = this.timeAxis;
    var stepResponseSetup = this.stepResponseSetup;
    var result = timeAxis.map((timePoint) => {
      var res = ResultsUtils.computeSecondOrderStepResponseIdeal(timePoint, stepResponseSetup);
      return res;
    });

    return result;
  }
}
